import styled from 'styled-components';
import { minWidth } from 'helpers/buildMediaQueries';
import {
  labelAndIconInGridStyles,
  labelNoWrapStyles
} from '../LabelAndIconInGrid.styles';
import {
  fontVariables,
  gutterVariables
} from '@trustedshops/tps-seo-shared-frontend-react-components';

export const CategoryOpener = styled.div`
  font-size: ${fontVariables.SIZE_TEXT_M};
  line-height: ${fontVariables.LINE_HEIGHT_L};
  padding: ${gutterVariables.GUTTER_HALF} 0;
  ${labelAndIconInGridStyles};
  cursor: pointer;

  ${minWidth('xl', 'display: none;')}
`;

export const CategoryOpenerText = styled.span<{ $categorySet: boolean }>`
  ${(props) =>
    props.$categorySet && `font-weight: ${fontVariables.FONT_WEIGHT_BOLD};`}
  ${labelNoWrapStyles}
`;
